// Needs attention view in the URL: whitelisted values, defaults left out.
import {
  DEFAULT_DIR,
  DEFAULT_SORT,
  ISSUE_CODE_RE,
  ISSUE_SORTS,
  ISSUE_STATUS_OPTIONS,
  VIEW_DAILY,
  VIEW_MONTHLY,
  parse_needs_attention_deep_link,
  SORT_DIRS
} from './params';

// teacher_uuid is the legacy name (Slack digests, run rows): read, never written.
const OWN_KEYS = [
  'view',
  'day',
  'tier',
  'cat',
  'code',
  'teacher',
  'teacher_uuid',
  'status',
  'sort',
  'list'
];

const has = (options, v) => options.some((o) => o.value === v);
const default_sort = () => ({ key: DEFAULT_SORT, dir: DEFAULT_DIR });

// 'key|dir' from the Sort select or a header click; anything else is the default order.
const parse_sort = (v) => {
  const [key, dir] = v.split('|');
  return ISSUE_SORTS.indexOf(key) !== -1 && SORT_DIRS.indexOf(dir) !== -1
    ? { key, dir }
    : default_sort();
};

export const blank_na_url = () => ({
  view: VIEW_MONTHLY,
  pay_month: '',
  day: '',
  tier: '',
  cat: false,
  code: '',
  teacher: '',
  status: '',
  sort: default_sort(),
  list_all: false
});

// ?view=daily&day= | ?tier=&cat=1&code=&teacher=&status=&sort=key|dir&list=1
export const parse_na_url = (search, today) => {
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  const get = (k) => (qs.get(k) || '').trim();
  const link = parse_needs_attention_deep_link(search, today);
  // The categories step only exists for one tier and no teacher (index.jsx by_category).
  const cat = get('cat') === '1' && !!link.tier && !link.teacher_uuid;
  return {
    view: link.view,
    pay_month: link.pay_month,
    day: link.day,
    tier: link.tier,
    cat,
    code: cat && ISSUE_CODE_RE.test(get('code')) ? get('code') : '',
    teacher: link.teacher_uuid,
    status: has(ISSUE_STATUS_OPTIONS, get('status')) ? get('status') : '',
    sort: parse_sort(get('sort')),
    list_all: get('list') === '1'
  };
};

// The shell's parsed digest link fills what the URL itself does not carry (tests mount without one).
export const merge_deep_link = (url, deep_link) => {
  const d = deep_link || {};
  return {
    ...url,
    view: url.view === VIEW_DAILY || d.view === VIEW_DAILY ? VIEW_DAILY : VIEW_MONTHLY,
    pay_month: url.pay_month || d.pay_month || '',
    day: url.day || d.day || '',
    tier: url.tier || d.tier || '',
    teacher: url.teacher || d.teacher_uuid || ''
  };
};

// Merged into the current search so ?month= and every other param survive.
export const na_url_search = (search, state, today) => {
  const s = { ...blank_na_url(), ...(state || {}) };
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  OWN_KEYS.forEach((k) => qs.delete(k));
  // The shell writes ?month=; a stale digest pay_month= beside it would mis-scope a reload.
  if (qs.get('month')) qs.delete('pay_month');
  if (s.view === VIEW_DAILY) {
    qs.set('view', VIEW_DAILY);
    if (s.day && s.day !== today) qs.set('day', s.day);
    return qs.toString();
  }
  if (s.tier) qs.set('tier', s.tier);
  if (s.tier && s.cat) {
    qs.set('cat', '1');
    if (s.code) qs.set('code', s.code);
  }
  if (s.teacher) qs.set('teacher', s.teacher);
  if (s.status) qs.set('status', s.status);
  const sort = s.sort || default_sort();
  if (sort.key !== DEFAULT_SORT || sort.dir !== DEFAULT_DIR)
    qs.set('sort', `${sort.key}|${sort.dir}`);
  if (s.list_all) qs.set('list', '1');
  return qs.toString();
};
